import React from 'react';
import {
    Box,
    Text,
    Flex,
    IconButton,
    Tooltip,
} from "@chakra-ui/react";
import { DeleteIcon, CheckIcon } from "@chakra-ui/icons";
import { fileSize } from '../../utils/helper';

export const PptCard = ({ ppt, onDelete, isHideDelete = false, isSelection = false, selectMedia, mediaUrl, showTooltip = false }) => {
    const size = fileSize(ppt);
    const url = !Array.isArray(mediaUrl) ? [mediaUrl] : mediaUrl;
    
    return (
        <Tooltip label={ppt.name} visibility={showTooltip ? "visible" : "hidden"}>
            <Box
                key={ppt.id}
                bg="white"
                boxShadow="md"
                borderRadius="lg"
                overflow="hidden"
                position="relative"
                _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
                backgroundColor={url.includes(ppt.url) ? "blue.200" : "white"}
                onClick={isSelection ? () => selectMedia("ppt", "", ppt) : () => window.open(ppt.url, "_blank")}
            >
                <Box p={5}>
                    <Text fontWeight="bold" isTruncated>
                        {ppt.name}
                    </Text>
                    <Flex justify="space-between" align="center">
                        <Text fontSize="sm" color="gray.500">
                            {size}
                        </Text>
                        {
                            !isHideDelete ? (
                                <IconButton
                                    aria-label="Delete"
                                    icon={<DeleteIcon />}
                                    size="sm"
                                    variant="ghost"
                                    colorScheme="red"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete(ppt.id);
                                    }}
                                />
                            ) : (
                                url.includes(ppt.url) && <CheckIcon color="blue.500" />
                            )
                        }
                    </Flex>
                </Box>
            </Box>
        </Tooltip>
    );
};
